import React, { useRef } from "react";
import moment from "moment";
import { useSize } from "ahooks";
import { useStore, useSelector } from "react-redux";
import { Scrollbars } from "react-custom-scrollbars-2";
import { p3StartTime, p3EndTime } from "@/models/layer";
import DateGrid from "@/components/panel/DateGrid";
import styles from "./index.module.less";

function getVirtulData() {
  const results = [];

  const p2Date = moment(p3StartTime);
  const p2End = p3EndTime;

  while (p2Date.add(1, "days").isBefore(p2End)) {
    results.push(p2Date.format("YYYY-MM-DD"));
  }

  return results;
}
const value = getVirtulData();
function BottomPanelContainer() {
  const ref = useRef();
  const { width } = useSize(ref);
  const { select } = useStore();
  const { minDate, maxDate } = useSelector(select.layer.selectDateRange);
  console.log(minDate, maxDate, value);
  const mode = useSelector((state) => state.panel.mode);
  console.log(mode);
  if (mode === "detection") return null;
  return (
    <div className={styles.bottomPanelContainer} ref={ref}>
      <Scrollbars>
        <DateGrid startDate={minDate} endDate={maxDate} dates={value} />
      </Scrollbars>
    </div>
  );
}

export default BottomPanelContainer;
